module.exports = __webpack_public_path__ + "img/charles-hamilton-houston.5a83c31e.png";